<template>
  <div class='collection'>
    <div class="time-limit-goods-wrapper">
      <div class="header">
        <div class="icon">秒杀</div>
        <div class="countdown">
          <div class="count-right">
            <span class="count-word">距开始还有</span>
            <span class="count-time">00</span>
            <span class="time-default-color">天</span>
            <span class="count-time">00</span>
            <span>:</span>
            <span class="count-time">00</span>
            <span>:</span>
            <span class="count-time">00</span>
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="goods-item">
          <div class="goods-img">
            <img class="img" :src="timeLimitGoodsItem.product.pic">
          </div>
          <div class="goods-content">
            <div class="title">{{timeLimitGoodsItem.product.name}}</div>
            <div class="price">
              ¥{{(timeLimitGoodsItem.product.mini_price / 100).toFixed(2)}}
              <span>{{(timeLimitGoodsItem.product.origin_price / 100).toFixed(2)}}</span>
            </div>
          </div>
        </div>
        <div class="btn-wrapper">
          <div class="text">剩余{{timeLimitGoodsItem.product.inventory_total}}件</div>
          <div class="btn">马上抢</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="span/ecmascript-6">
export default {
  name: 'Goods',
  props: {
    timeLimitGoodsItem: {
      type: Object,
      default: () => { },
    },
  },
  data () {
    return {

    }
  },
  methods: {},
  mounted () { },
}
</script>

<style scoped lang="stylus">
.collection
  margin-bottom 20px
  .time-limit-goods-wrapper
    box-sizing border-box
    width 100%
    height 210px
    background linear-gradient(141deg, rgba(255, 155, 0, 1) 0%, rgba(255, 62, 0, 1) 100%)
    .header
      box-sizing border-box
      display flex
      justify-content space-between
      padding 7px 0
      height 42px
      .icon
        flex 0 0 49px
        height 27px
        background url('~@/assets/template/pin-miao.png') no-repeat center center / cover
        color #fff
        font-size 12px
        line-height 27px
        padding-left 10px
      .countdown
        flex 1
        padding-right 5px
        height 27px
        line-height 27px
        text-align right
        color #fff
        .count-word
          margin-right 17px
        .count-time
          margin 0 3px
          padding 2px
          background #fff
          color #DD1D21
          border-radius 4px
    .content-box
      background #fff
      box-sizing border-box
      padding 15px
      height 163px
      width calc(100% - 10px)
      position relative
      left 5px
      bottom 0
      .goods-item
        display flex
        justify-content space-between
        height 94px
        border-bottom 1px solid #F8ECDD
        .goods-img
          width 134px
          height 84px
          .img
            width 100%
            height 100%
        .goods-content
          display flex
          flex-direction column
          justify-content space-between
          width 158px
          height 84px
          font-size 14px
          .title
            width 158px
            height 42px
            line-height 21px
            font-size 14px
            color #404040
            overflow hidden
            text-overflow ellipsis
            display -webkit-box
            -webkit-line-clamp 2
            -webkit-box-orient vertical
          .price
            font-size 16px
            color #DD1D21
            span
              font-size 10px
              color #C1C1C1
              text-decoration line-through
      .btn-wrapper
        box-sizing border-box
        display flex
        justify-content flex-end
        align-items center
        padding 10px 0 15px 0
        height 53px
        .btn
          margin-left 10px
          width 70px
          height 28px
          line-height 28px
          font-size 12px
          text-align center
          color #fff
          background url('~@/assets/template/mobile-goods-btn.png') no-repeat center
          background-size 70px 28px
</style>



// WEBPACK FOOTER //
// src/components/content/modal/TimeLimitGoods.vue